import React, { useEffect } from 'react';
import MetaTags from './components/MetaTags';

const TestPage = () => {
  useEffect(() => {
    console.log('TestPage loaded - check browser tab title');
  }, []);

  return (
    <div>
      <MetaTags 
        title="TEST PAGE - This Should Show in Browser Tab"
        description="This is a test page to verify React Helmet is working"
        ogTitle="TEST PAGE - This Should Show in Browser Tab"
        ogDescription="This is a test page to verify React Helmet is working"
        twitterTitle="TEST PAGE - This Should Show in Browser Tab"
        twitterDescription="This is a test page to verify React Helmet is working"
      />
      <h1>Test Page</h1>
      <p>Check the browser tab title - it should show TEST PAGE</p>
      <p>If you see this title in the browser tab, React Helmet is working!</p>
    </div>
  );
};

export default TestPage;